import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import type { Fund } from "@/types";

export function useFunds() {
  return useQuery({
    queryKey: ["funds"],
    queryFn: async () => {
      const { data } = await apiClient.get<Fund[]>("/funds");
      return data;
    },
  });
}

export function useCreateFund() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { name: string }) => {
      const { data } = await apiClient.post<Fund>("/funds", payload);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["funds"] }),
  });
}

export function useUpdateFund() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...payload }: Partial<Fund> & { id: string }) => {
      const { data } = await apiClient.put<Fund>(`/funds/${id}`, payload);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["funds"] }),
  });
}
